import AIStudio from './AIStudio'

export default AIStudio
